import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'
import { migratePopup } from './migrate-popup'

export default function (page: ServerPage) {
  return migrateCommand({
    page,
    structureType: structureTypes.POPUP,
    migrateFunction: migratePopup,
  })
}
